import { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { fromJS } from 'immutable';

// COMPONENTS
import { RadioButton } from 'components/RadioButtons';
import MaybeTranslation from 'components/MaybeTranslation';
import { CancelButton, PrimaryButton } from 'components/Buttons';

// STYLES
import {
  FilterFormContainer,
  FilterFormTitle,
  ButtonsContainer,
  FilterItemGroup,
  RadioContainer,
  FilterInput,
} from './styles';

// CONSTANTS
import { FILTER_FORM } from 'constants/filters';

// TYPE

class NumberConfiguration extends Component {
  state = {
    query: '',
    option: FILTER_FORM.number[0],
  };

  getFormItems = () =>
    FILTER_FORM.number.map((item) => (
      <FilterItemGroup key={`number-filter-${item.translation}`} data-testid={`filter__${item.translation}`}>
        <RadioContainer>
          <RadioButton
            onClick={this.handleChangeOption(item)}
            // @ts-expect-error TS(2769): No overload matches this call.
            selected={item.translation === this.state.option.translation}
            renderedValue={{
              translationId: `components.Filters.${item.translation}`,
            }}
          />
        </RadioContainer>

        {item.translation === this.state.option.translation && this.state.option.type === 'input' && (
          <FilterInput
            type="number"
            name="query"
            // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
            placeholder={this.props.intl.formatMessage({
              id: 'components.Filters.valuePlaceholder',
            })}
            value={this.state.query}
            onChange={this.handleChangeQuery}
          />
        )}
      </FilterItemGroup>
    ));

  handleChangeQuery = (event) => {
    this.setState({ query: event.currentTarget.value });
  };

  handleChangeOption = (option) => () => {
    this.setState({ option });
  };

  handleSaveFilter = () => {
    let value = null;

    if (this.state.option.type) {
      value = this.state.query;
    } else if (this.state.option.translation === 'isKnown') {
      value = '0';
    } else if (this.state.option.translation === 'isUnknown') {
      value = '1';
    }

    // @ts-expect-error TS(2339): Property 'onSave' does not exist on type 'Readonly... Remove this comment to see the full error message
    this.props.onSave(
      fromJS({
        comparator: this.state.option.comparator,
        // @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
        field: this.props.column.get('name'),
        value,
      })
    );
  };

  render() {
    return (
      <FilterFormContainer>
        <FilterFormTitle>
          {/* @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message */}
          <MaybeTranslation renderedValue={this.props.column.get('title')} />
        </FilterFormTitle>

        {this.getFormItems()}

        <ButtonsContainer>
          {/* @ts-expect-error TS(2339): Property 'onCancel' does not exist on type 'Readon... Remove this comment to see the full error message */}
          <CancelButton onClick={this.props.onCancel} />
          <PrimaryButton data-testid="filters__apply" onClick={this.handleSaveFilter}>
            <FormattedMessage id="components.Filters.apply" />
          </PrimaryButton>
        </ButtonsContainer>
      </FilterFormContainer>
    );
  }
}

// @ts-expect-error TS(2769): No overload matches this call.
export default injectIntl(NumberConfiguration);
